var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", id: "alerts-banner" } },
    [
      _vm._l(_vm.messages, function(message, index) {
        return [
          _c(
            "v-alert",
            {
              key: index,
              attrs: {
                value: message.show,
                color: message.type,
                icon: message.icon,
                transition: "slide-x-reverse-transition"
              }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(message.handleShowEvent()) +
                  "\n            "
              ),
              _c("strong", [_vm._v(_vm._s(message.text))])
            ]
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29ce9aa7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29ce9aa7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FlashMessage.vue
// module id = pgH9
// module chunks = 1